<template>
  <div class="i-order">
    <div class="up">
      <!-- 我的地址 -->
      <div class="facab">
        <div class="oText">{{ $t('main.myInquiry') }}</div>
      </div>
    </div>
    <div class="down">
      <div class="fac tHeader">
        <div class="oDetail">{{ $t('main.InquiryList') }}</div>
        <div class="oP">{{ $t('main.consignee') }}</div>
        <div class="oP">{{ $t('main.Manage') }}</div>
      </div>
      <div v-for="(item, index) in inquiryList" :key="index">
        <div class="otime facab">
          <div class="fac">
            <div> {{ $t('main.InquiryNumber') }}：{{ item.sn }}</div>
          </div>
          <div class="sTime">{{ $t('main.InquiryDate') }}：{{ handleTimeToString(item.create_time) }}</div>
          <!-- <div class="sTime">剩余支付时间：01时52分10秒</div> -->
        </div>
        <div class="fac tContent">
          <div class="oDetail fac">
            <img style="cursor: pointer;" @click="gotoProductDetail(item.sn_product_list[0])" :src="item.sn_product_list[0].thumb" class="pImg" />
            <div class="ml20">
              <div class="fac">
                <div style="width: 12rem">{{ $t('main.totalNum') }}</div>
                <div style="width: calc(100% - 12rem);">X {{ item.total_number }}</div>
              </div>
              <div class="fac">
                <div style="width: 12rem">{{ $t('main.product') }}</div>
                <div style="width: calc(100% - 12rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item.sn_product_list[0])">{{ item.sn_product_list[0].type_name }}</div>
              </div>
              <div class="fac">
                <div style="width: 12rem">{{ $t('main.partNumber') }}</div>
                <div style="width: calc(100% - 12rem);cursor: pointer;color: #635796;" @click="gotoProductDetail(item.sn_product_list[0])">{{ item.sn_product_list[0].product_model }}</div>
              </div>
              <div
                class="fac  color-999"
                v-for="(itemps, index) in item.sn_product_list[0].product_data"
                v-if="itemps.isShow"
                :key="index"
              >
                <div style="width: 12rem">{{ itemps.title }}</div>
                <div style="width: calc(100% - 12rem);">{{ itemps.value }}</div>
              </div>
              <div
                  class="fac  color-999"
                  v-for="(itemps, index) in item.sn_product_list[0].product_data"
                  v-if="!itemps.isShow && showMore.findIndex(res=>{return res == item.id;}) > -1"
                  :key="index"
              >
                <div style="width: 12rem">{{ itemps.title }}</div>
                <div style="width: calc(100% - 12rem);">{{ itemps.value }}</div>
              </div>
              <div class="fac color-635796" style="cursor: pointer;" @click="handleProductParamsMore(item)">
                {{ showMore.findIndex(res=>{return res == item.id;}) > -1 ? $t('main.Cut') : $t('main.More') }}
                <i :class="showMore.findIndex(res=>{return res == item.id;}) > -1 ? 'el-icon-arrow-up':'el-icon-arrow-down'"></i>
              </div>
            </div>
          </div>
          <div class="oP oCenter">
            <div class="cCtext">
              {{ item.address_info.receive_user }}
            </div>
          </div>
          <div class="oP oCenter">
            <div class="cCtext">
              <div @click="gotoDetail(item.sn)">
                {{ $t('main.Detail') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-data" v-if="!inquiryList.length"> {{ $t('main.noData') }}</div>
    </div>
    <div class="pagination">
      <el-pagination
          layout="prev, pager, next"
          hide-on-single-page
          :total="total"
          :current-page="page"
          :page-size="limit"
          @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { inquiryList } from '@/api/inquiry'
import {getProductInfo} from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      inquiryList: [],
      //一次全部查询出来因为还要知道各种订单的数量   "0|未支付,1|已支付，未发货,2|已发货，未收货,3|已收货，未评价,4|已评价，已完成,8|已删除,9|已取消",
      page: 1, // 当前页码
      limit: 5, // 一页展示几条
      total: 0, // 总条数
      showMore: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    }
  },
  watch: {
    "$store.state.siteInfo": function(newV) {
      if (newV) {
        this.init();
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getInquiryList()
    },
    //到产品界面
    gotoProductDetail(item) {
      let params = {
        req: {
          id: item.type_id
        }
      };
      getProductInfo(params).then(res => {
        if(res.rsp.code === 0) {
          const toItem = res.data;
          let route = this.$router.resolve({
            path: this.getRoutesPath('detail_product', toItem['identification'], toItem['id']),
            query: {
              keyword: item.product_model,
              anchor: "filter"
            }
          });
          window.open(route.href, "_blank");
          window.sessionStorage.setItem("recommend", true);
        } else {
          this.$message({
            message: res.rsp.msg,
            type: "error",
          });
        }
      });
    },
    handleProductParamsMore(item) {
      let isExit = this.showMore.findIndex(res=>{
        return res == item.id;
      });
      if (isExit > -1) {
        this.showMore.splice(isExit, 1);
      } else {
        this.showMore.push(item.id);
      }
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    handleTimeToString(v) {
      // let date = new Date(parseInt(v) - 1000);
      // let Y = date.getFullYear();
      // let M = date.getMonth() + 1;
      // let D = date.getDate();
      // let H = date.getHours();
      // let m = date.getMinutes();
      // let s = date.getSeconds();
      // return `${Y}-${M}-${D} ${H}:${m}:${s}`;
      var chazhi = Cookies.get("Difference");
      var benditime = v*1000-chazhi;
      let date = new Date(benditime);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      M = M > 9 ? M : "0" + M;
      let D = date.getDate();
      D = D > 9 ? D : "0" + D;
      let H = date.getHours();
      H = H > 9 ? H : "0" + H;
      let m = date.getMinutes();
      m = m > 9 ? m : "0" + m;
      let s = date.getSeconds();
      s = s > 9 ? s : "0" + s;
      return `${Y}-${M}-${D} ${H}:${m}:${s}`;
    },
    gotoDetail(orderid) {
      // console.log(orderid)
      this.$router.push(
          {
            path: '/userCenter/inquirydetail',
            query: { id: orderid }
          }
      )
    },
    //点击获取
    getInquiryList() {
      let inquiryListParams = {
        req: {
          page: this.page,
          limit: this.limit,
          where: [
            {
              condition: Cookies.get("siteInfo"),
              filed: "site_id",
              expression: "="
            },
          ],
          order: 'id desc',
        },
      }
      inquiryList(inquiryListParams).then((res) => {
        this.inquiryList = res.data.list;
        this.total = res.data.total;
      })
    },
    handleCurrentChange(val) {
      this.page = val
      this.getInquiryList()
    },
  },
}
</script>

<style scoped lang="less">
.i-order {
  min-height: 46.25rem;
  background: #fafafa;
  border: 1px solid #e5e5e5;
  .up {
    width: 100%;
    height: 4.375rem;
    background: #f2f2f2;
    border-bottom: 1px solid #e5e5e5;
    line-height: 4.375rem;
    .tEnd {
      width: 15%;
      text-align: center;
      cursor: pointer;
    }
    .oText {
      color: #1a1a1a;
      margin-left: 1.5rem;
      cursor: pointer;
    }
    .active {
      color: #635796 !important;
    }
  }
  .down {
    max-height: calc(46.25rem - 12.375rem);
    overflow-y: auto;
    .no-data {
      width: 100%;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }
    .tHeader {
      height: 4.375rem;
      line-height: 4.375rem;
      color: #1a1a1a;
    }
    .otime {
      height: 4.375rem;
      line-height: 4.375rem;
      background-color: #f2f2f2;
      color: #999999;
      padding: 0 1.875rem 0 1.5rem;
    }
    .tContent {
      padding: 1rem 0;
      border: 1px solid #e6e6e6;
      border-radius: 0.5rem;
      .pImg {
        width: 7.5rem;
      }
      .oCenter {
        display: flex;
        /deep/ .el-button--danger {
          background-color: #635796;
          border-color: #635796;
        }
        .cCtext {
          div {
            cursor: pointer;
          }
        }
      }
      .cCtext {
        margin: auto;
      }
    }
    .oDetail {
      min-width: 50%;
      padding-left: 1.5rem;
    }
    .oT {
      min-width: 10%;
      height: 100%;
      border-left: 1px solid #e5e5e5;
      text-align: center;
    }
    .oP {
      min-width: 15%;
      width: 30%;
      height: 100%;
      border-left: 1px solid #e5e5e5;
      text-align: center;
    }
    .ml20 {
      margin-left: 0.5rem;
    }
    .mt10 {
      margin-top: 0.625rem;
    }
    .mb20 {
      margin-bottom: 1.25rem;
    }
    .mt20 {
      margin-top: 0.5rem;
    }
    .color-999 {
      color: #999999;
    }
    .pagination {
      width: 100%;
      text-align: center;
      margin: 0.5rem 0;
    }
  }
  .color-80 {
    color: #808080;
  }

  /deep/ .el-pager li {
    background: #fff;
    margin: 0.1rem;
  }
  /deep/ .el-pagination {
    text-align: center;
  }
  /deep/ .el-pagination button:hover,.el-pagination button:focus,.el-pagination button:active {
    color: #635796;
  }
  /deep/ .el-pager li.active {
    background: #635796;
    color: #fff!important;
  }
  /deep/ .el-pager li:hover {
    background: #635796;
    color: #fff!important;
  }
}
</style>
